import { render, staticRenderFns } from "./PortinList.vue?vue&type=template&id=61008a21&scoped=true&"
import script from "./PortinList.vue?vue&type=script&lang=js&"
export * from "./PortinList.vue?vue&type=script&lang=js&"
import style0 from "./PortinList.vue?vue&type=style&index=0&id=61008a21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61008a21",
  null
  
)

export default component.exports